import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import "./gallery.css";

const Gallery = () => {
  const [galleryMedia, setGalleryMedia] = useState([]);

  useEffect(() => {
    fetch("https://api.deepticentre.com/deeptischool/list/gallery-image", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.result && data.list) {
          const mediaItems = data.list
            .filter((item) => item.g_status === "active")
            .map((item) => {
              const url = `https://api.deepticentre.com${item.g_file}`;
              const isVideo = url.match(/\.(mp4|webm|ogg)$/i);
              return { url, type: isVideo ? "video" : "image" };
            });
          setGalleryMedia(mediaItems);
        }
      })
      .catch((err) => {
        console.error("Error fetching gallery media:", err);
      });
  }, []);

  useEffect(() => {
    const images = document.querySelectorAll(".gallery-images");

    images.forEach((img) => {
      img.addEventListener("touchstart", () => {
        img.classList.add("hover-effect");
      });

      img.addEventListener("touchend", () => {
        setTimeout(() => img.classList.remove("hover-effect"), 500);
      });
    });

    return () => {
      images.forEach((img) => {
        img.removeEventListener("touchstart", () => {});
        img.removeEventListener("touchend", () => {});
      });
    };
  }, [galleryMedia]);

  return (
    <Container className="gallery">
      <h2 className="gallery-page-heading text-center my-4">OUR GALLERY</h2>
      <Row>
        {galleryMedia.map((media, index) => (
          <Col key={index} xs={12} sm={6} md={4} className="mb-4">
            <motion.div
              initial={{ x: index % 2 === 0 ? -100 : 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              {media.type === "image" ? (
                <Image
                  className="gallery-images"
                  src={media.url}
                  alt={`Gallery ${index}`}
                  thumbnail
                  fluid
                />
              ) : (
                <video
                  className="gallery-images"
                  controls
                  width="100%"
                  poster=""
                >
                  <source src={media.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </motion.div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Gallery;
